import {useEffect,useState, useRef} from 'react'
import axios from 'axios'
//import { useNavigate } from 'react-router-dom'
//import {UserEditModalHeader} from './UserEditModalHeader'
//import {UserEditModalFormWrapper} from './UserEditModalFormWrapper'
import { ViewModalHeader } from './ViewModalHeader'
import { getTicketsID } from '../requests/request'
import { KTSVG } from '../../../../../_metronic/helpers'
import { Card4 } from '../../../../../_metronic/partials/content/cards/Card4'
import './APP.css'
import { useAuth } from '../../../auth'
import Swal from 'sweetalert2'
import { useAppSelector } from '../../../../../redux/hooks'
 
const API_URL = process.env.REACT_APP_API_URL
 
 
 
const ViewModal = ( props:any ) => {
  /***************************************************** */
  const tenant= useAppSelector(state =>state.TenantSlice.id)
 
  const{currentUser}= useAuth()
 
  const [Idtik,setIdtik]= useState({
    date: {
      "friendly": '',
      "iso8601": ''
    },
    "datastatus": {
      "friendly":'',
      "iso8601": ''
    },
    custom_fields:{
      "segundo_nivel":'',
      "cf_contrato_po": '',
      "cf_tipo": '',
      "cf_solicitud":'',
      "cf_personal_de_contacto": '',
      "cf_correo_de_contacto":''
    },
   description_text:'',
   attachments:[{}],
   conversations:[{}],
 
   status:"",
   subject:"",
   priority:0,
 
 
 
    })
  /***************************************************** */
 
  useEffect(() => {
    document.body.classList.add('modal-open')
    return () => {
      document.body.classList.remove('modal-open')
    }
  }, [])
 
  useEffect(() => {
    //colocar llamada al ep de ticket for id
    const fetchData = async () => {
      try {
        if( props.id !== "" ){
        const Suscripcion = await getTicketsID(props.id);
 
        setIdtik(Suscripcion.data);
        }
      } catch (error) {
        console.error('Error al obtener las cuentas:', error);
      }
       };
 
      fetchData();
 
  }, [props.id])
  /************************************************** */
  const [Reply, setReply] = useState('');
  const [files, setfiles] = useState<File[]|string>();
  const inputRef = useRef<HTMLInputElement>(null);
 
  const resetFileInput = () => {
    if (inputRef.current){
      inputRef.current.value = ''};
  };
 
 
 
 
  const handleChange = (event:any) => {
    setfiles(
        event.target.files
    )}
 
    const handleSubmit =async (e:any) => {
      e.preventDefault();
   
 
    try{
      var formData = new FormData();
        if(files){
          for(const x of files){
      formData.append("files[]", x);}}
      formData.append("reply", Reply)
 
 
 
    await axios.post(API_URL+'/v1/support/ReplyTicket/'+props.id, formData,{
        headers: {
          'Content-Type': 'multipart/form-data'
        }
    })
      await getTicketsID(props.id)
      .then(res=>{
        setIdtik(res.data);
        setReply('');
        setfiles('');
        resetFileInput()
        Swal.fire({
        position: 'center',
        icon: 'success',
        title: 'Your message has been sent',
        showConfirmButton: false,
        timer: 1500
      })});
 
    }
    catch(error:any){
      console.log(error)
 
    }
   
   }
   /*******************************descargar imagen de la conversación************************/
   const handleDownload = async (id:any, filename:any) => {
    try {
      const response = await axios.get(API_URL + '/v1/support/attachmentcontent/' + props.id + '/' + id, {
        responseType: 'blob', // Mantenemos la respuesta como un blob
      });
 
      // Crear un objeto URL para el blob
      const url = window.URL.createObjectURL(response.data);
      // Crear un enlace temporal para iniciar la descarga
      const link = document.createElement('a');
      link.href = url;
      
      // Establecer el atributo 'download' para que el archivo se descargue automáticamente
      link.setAttribute('download', filename || 'archivo_descargado'); // Si no se proporciona un nombre de archivo, se usa uno predeterminado
 
      // Hacer clic en el enlace para iniciar la descarga
      document.body.appendChild(link);
      link.click();
 
      // Limpiar el objeto URL y eliminar el enlace temporal
      window.URL.revokeObjectURL(url);
      link.remove();
    } catch (error) {
      console.error('Error al descargar el archivo:', error);
    }
  };
  const handleDownloadoldconv = async (id:any, filename:any) => {
    try {
      const response = await axios.get(API_URL + '/v1/support/attachmentcontent_conve_old/' + props.id + '/' + id+ '/' + filename, {
        responseType: 'blob', // Mantenemos la respuesta como un blob
      });
 
      // Crear un objeto URL para el blob
      const url = window.URL.createObjectURL(response.data);
 
      // Crear un enlace temporal para iniciar la descarga
      const link = document.createElement('a');
      link.href = url;
 
      // Establecer el atributo 'download' para que el archivo se descargue automáticamente
      link.setAttribute('download', filename || 'archivo_descargado'); // Si no se proporciona un nombre de archivo, se usa uno predeterminado
 
      // Hacer clic en el enlace para iniciar la descarga
      document.body.appendChild(link);
      link.click();
 
      // Limpiar el objeto URL y eliminar el enlace temporal
      window.URL.revokeObjectURL(url);
      link.remove();
    } catch (error) {
      console.error('Error al descargar el archivo:', error);
    }
  };
 
  const handleDownloadold = async (id:any, filename:any) => {
    try {
      const response = await axios.get(API_URL + '/v1/support/attachmentcontent_old/' + props.id + '/' + filename, {
        responseType: 'blob', // Mantenemos la respuesta como un blob
      });
 
      // Crear un objeto URL para el blob
      const url = window.URL.createObjectURL(response.data);

 
      // Crear un enlace temporal para iniciar la descarga
      const link = document.createElement('a');
      link.href = url;
 
      // Establecer el atributo 'download' para que el archivo se descargue automáticamente
      link.setAttribute('download', filename || 'archivo_descargado'); // Si no se proporciona un nombre de archivo, se usa uno predeterminado
 
      // Hacer clic en el enlace para iniciar la descarga
      document.body.appendChild(link);
      link.click();
 
      // Limpiar el objeto URL y eliminar el enlace temporal
      window.URL.revokeObjectURL(url);
      link.remove();
    } catch (error) {
      console.error('Error al descargar el archivo:', error);
    }
  };
 
 
  /******************************* */
  useEffect(() => {
    // Obtener el elemento del chat-content
    const chatContent = document.getElementById('chat-content');
 
    // Verificar si el elemento existe
    if (chatContent) {
      // Hacer que el scroll esté siempre al final del contenedor
      chatContent.scrollTop = chatContent.scrollHeight;
    } else {
      console.error("No se encontró el elemento con el id 'chat-content'");
    }
  }, [Idtik.conversations]); // Se ejecutará cada vez que cambie la conversación
 
  function formatDate(dateString: string): string {
    if (!dateString) return ''; // Si no hay fecha, devolver cadena vacía
   
    const date = new Date(dateString); // Convertir la cadena a un objeto Date
 
    // Obtener el día, mes y año en el formato deseado
    const day = date.getUTCDate().toString().padStart(2, '0');
    const month = (date.getUTCMonth() + 1).toString().padStart(2, '0'); // Mes comienza desde 0
    const year = date.getUTCFullYear();
 
    // Formatear la fecha en el formato DD-MM-AAAA
    return `${day}-${month}-${year}`;
  }
 
  return (
    <>
      <script src="https://cdn.tailwindcss.com"></script>
     
      <div
        className='modal fade show d-block'
        id='kt_modal_add_user'
        role='dialog'
        tabIndex={-1}
        aria-modal='true'
      >
        {/* begin::Modal dialog */}
        <div className='modal-dialog modal-dialog-centered mw-650px'>
          {/* begin::Modal content */}
          <div className='modal-content'>
            <ViewModalHeader setID={props.setID} />
            {/* begin::Modal body */}
            <div className='modal-body scroll-y  mx-5 mx-xl-15 my-7'>
            {/*<Card4
              icon='/media/imgv2/logo_rosa_dos.png'
              title=' '
  description=''></Card4>*/}
 
              <div className='text-center mb-5'>
                  <h1 className='text-marino fw-bolder mb-3 f-titulo fs-md '>Ticket No. {props.id}</h1>
                  <h3 className='text-marino fw-bolder mb-3 f-titulo'>Title: {Idtik.subject}</h3>
 
              </div>
              <div className='text-center mb-5 f-parrafo'>
                  {/*Idtik.priority === 1 && <span className='badge fs-3 badge-light-primary'>Priority: Low</span>}
                  {Idtik.priority === 2 && <span className='badge fs-3 badge-light-warning'>Priority: Medium</span>}
                  {Idtik.priority === 3 && <span className='badge fs-3 badge-light-info'>Priority: High</span>}
{Idtik.priority === 4 && <span className='badge fs-3 badge-light-danger'>Priority: Urgent</span>*/}
                  {typeof props.id === 'string' && (props.id.includes('CRE') || props.id.includes('TRE')) && (Idtik.priority === 1 || Idtik.priority === 10000  ) ?<span className='badge fs-4 badge-light-danger'>Priority: Urgent</span>:Idtik.priority === 1 && <span className='badge fs-4 badge-light-primary'>Priority: Low</span>}
                  {typeof props.id === 'string' &&(props.id.includes('CRE') || props.id.includes('TRE')) &&Idtik.priority === 2 ? <span className='badge fs-4 badge-light-info'>Priority: High</span>:Idtik.priority === 2 && <span className='badge fs-4 badge-light-warning'>Priority: Medium</span>}
                  {typeof props.id === 'string' &&(props.id.includes('CRE') || props.id.includes('TRE')) &&Idtik.priority === 3 ?<span className='badge fs-4 badge-light-warning'>Priority: Medium</span>:Idtik.priority === 3 && <span className='badge fs-4 badge-light-info'>Priority: High</span>}
                  {typeof props.id === 'string' &&(props.id.includes('CRE') || props.id.includes('TRE')) &&Idtik.priority === 4 ? <span className='badge fs-4 badge-light-primary'>Priority: Low</span>:Idtik.priority === 4 && <span className='badge fs-4 badge-light-danger'>Priority: Urgent</span>}
                                       
              </div>
             
             { Idtik.date&&Idtik.datastatus&& <table className='w-full f-parrafo  caption-bottom  custom-table'>
         
                <tbody>
                  <tr className='table-row'>
                    <td className='table-cell' style={{width:'200px'}}> <strong className='text-pink'>Created:</strong> {Idtik.date.friendly}</td>
                    <td className='table-cell'style={{width:'200px'}}><strong className='text-pink'>Last Update:</strong> {Idtik.datastatus.friendly}</td>
                  </tr>
                </tbody>
              </table>}
 
              {!(Idtik.custom_fields.cf_tipo.includes('New Feature')||Idtik.custom_fields.cf_tipo.includes('Feature Request')||Idtik.custom_fields.cf_tipo.includes('Help Request'))&&
              <table className='w-full f-parrafo  caption-bottom  custom-table'>
                <tbody>
                  <tr className='table-row'>
                    <td className='table-cell'style={{width:'200px'}}><strong className='text-pink'>Ticket Type:</strong> {Idtik.custom_fields.cf_tipo}</td>
                    <td className='table-cell'style={{width:'200px'}}><strong className='text-pink'>Topic:</strong> {Idtik.custom_fields.cf_solicitud}</td>
                  </tr>
                </tbody>
              </table>}
 
              {Idtik.custom_fields.cf_tipo.includes('Change Request')&&
                <div className='text-center'>
                  <p></p>
                  <strong className='text-pink'>Ticket specification:</strong> {Idtik.custom_fields.segundo_nivel}
                </div>
              }
 
              {(Idtik.custom_fields.cf_tipo.includes('New Feature')||Idtik.custom_fields.cf_tipo.includes('Feature Request')||Idtik.custom_fields.cf_tipo.includes('Help Request'))&&
                <div className='text-center'>
                  <p></p>
                  <strong className='text-pink'>Ticket Type:</strong> {Idtik.custom_fields.cf_tipo}
                </div>
              }
             
              <br />
             
             
              <div className='text-center mb-5 f-parrafo'>
                  <h3 className='text-marino fw-bolder mb-3'>Description</h3>
                  <textarea disabled  name="name" value={Idtik.description_text} className="form-control border-gray-300"/>
 
              </div>
              <br />
              <div className='text-center mb-0 f-parrafo'>
                <h3 className='text-marino fw-bolder mb-3'>Status</h3>
              </div>
              <div className='text-marino fw-bold text-hover-primary mb-4 fs-5 text-center f-parrafo'>              
                {
                Idtik.status.toString() ==="This ticket has been Resolved" ?<span className='badge badge-light-success'>{Idtik.status.toString()}</span>
                :Idtik.status.toString() ==="Resolved" ?<span   className='badge  badge-light-success'>{Idtik.status.toString()}</span>
                :Idtik.status.toString() ==="Completed" ?<span  className='badge  badge-light-success'>{Idtik.status.toString()}</span>
                :Idtik.status.toString() ==="This ticket has been Closed" ? <span className='badge  badge-light-dark'>{Idtik.status.toString()}</span>:
                Idtik.status.toString() ==="Closed" ? <span className='badge  badge-light-dark'>{Idtik.status.toString()}</span>
                :Idtik.status.toString() ==="Canceled" ? <span  className='badge  badge-light-danger'>{Idtik.status.toString()}</span>
                :Idtik.status.toString() ==="Declined" ?<span  className='badge  badge-light-danger'>{Idtik.status.toString()}</span>:
                <span  className='badge  badge-light-primary'>{Idtik.status.toString()} </span>  
                }
              </div>
              {Idtik.custom_fields.cf_personal_de_contacto&&Idtik.custom_fields.cf_personal_de_contacto !== null && <div className='text-marino fw-bold text-hover-primary fs-5 text-center f-parrafo'>
                Contact
              </div>}
              <div className="card-body f-parrafo">
           
               
                  <form>
                            <div>
                                {Idtik.custom_fields.cf_personal_de_contacto&&Idtik.custom_fields.cf_personal_de_contacto !== null&&<label htmlFor="name">Name:</label>}
                                {Idtik.custom_fields.cf_personal_de_contacto&&Idtik.custom_fields.cf_personal_de_contacto === null && <div className='text-dark fw-bold text-hover-primary fs-5 text-center'></div>}  
                                {Idtik.custom_fields.cf_personal_de_contacto&&Idtik.custom_fields.cf_personal_de_contacto !== null && <input disabled type="text" name="name" value={Idtik.custom_fields.cf_personal_de_contacto} className="form-control"/>}  
                            </div>
                            <div className='row'>
                            <div className='col'>
                                {Idtik.custom_fields.cf_correo_de_contacto&&Idtik.custom_fields.cf_correo_de_contacto !== null &&<label htmlFor="email">Email:</label>}
                                {Idtik.custom_fields.cf_correo_de_contacto&&Idtik.custom_fields.cf_correo_de_contacto !== null && <input disabled type="text" name="name" value={Idtik.custom_fields.cf_correo_de_contacto} className="form-control"/>}  
 
                            </div>
                            <div className='col'>
                                {Idtik.custom_fields.cf_contrato_po&&Idtik.custom_fields.cf_contrato_po !== null &&<label htmlFor="email">Phone:</label>}
                                {Idtik.custom_fields.cf_contrato_po&&Idtik.custom_fields.cf_contrato_po !== null && <input disabled type="text" name="name" value={Idtik.custom_fields.cf_contrato_po} className="form-control"/>}  
 
                            </div>
                            </div>
                    </form>
                    <div className='fv-row mb-3 text-center'>
                    {Idtik.attachments.length !== 0 &&
                    <div className='text-dark fw-bold text-hover-primary fs-5 text-center'>
                      Attachments
                    </div>}
                   
                    {Idtik.attachments.map((d:any,i)=>(
                      <button key={i} onClick={() => handleDownloadold(d.id,d.name)} className="btn btn-icon btn-light pulse me-10 mb-10 bg-light-info">
                        <KTSVG
                          path=""
                          className="bi bi-paperclip"
                        />
                        <span className="pulse-ring"></span>
 
                      </button>
                   
                    ))}
                   
 
                  </div>
                 
                { currentUser?.ListPermiso?.includes('Support.Update') &&
                <>  
                <div className='text-dark fw-bold text-hover-primary fs-5 text-center'>
                      Conversation
                  </div>
 
 
                  <div>
                    <div id="chatbox-area">
                      <div  id="chat-content" className="card-content chat-content border border-gray-400 rounded">
                        <div style={{margin:'15px'}} className="content">
                        {Idtik.conversations.map((d:any,i)=>(
                          <div>
                              {d.incoming === false &&<div className="chat-message-group">
                                <div className="chat-messages">
                                <img src="/media/iconos_v2/isotipo.png" className=' w-30px mr-4 from' alt='nube'  style={{borderRadius:'50%'}}/>
                                  <div className="message">{d.body_text}
                                  {d.attachments.length !==0 &&<div className=' fw-bold text-end'>Attached files:</div>}
                                  <div>
                                    {d.attachments.map((a:any,i:any)=>(
                                      <div className='text-end'>
                                     <button key={i} onClick={() =>(typeof props.id === 'string' && ( props.id.includes('CRE') || props.id.includes('TRE'))? handleDownload(a.id,a.name):handleDownloadoldconv(d.id,a.name))} className="btn btn-icon btn-light pulse me-10  bg-light-marino">
                                        {a.name.includes('pdf') && <KTSVG
                                          path=""
                                          className="bi bi-file-pdf"
                                        />}
                                        {a.name.toLowerCase().includes('png') && <KTSVG
                                          path=""
                                          className="bi bi-filetype-png"
                                        />}
                                        {a.name.toLowerCase().includes('xlsx') && <KTSVG
                                          path=""
                                          className="bi bi-filetype-xlsx"
                                        />}
                                        {a.name.toLowerCase().includes('jpg') && <KTSVG
                                          path=""
                                          className="bi bi-filetype-jpg"
                                        />}
                                        {a.name.toLowerCase().includes('jpeg') && <KTSVG
                                          path=""
                                          className="bi bi-filetype-jpg"
                                        />}
                                        {a.name.toLowerCase().includes('zip') && <KTSVG
                                          path=""
                                          className="bi bi-file-earmark-zip"
                                        />}
                                        {a.name.toLowerCase().includes('rar') && <KTSVG
                                          path=""
                                          className="bi bi-file-earmark-zip"
                                        />}
                                        {a.name.toLowerCase().includes('xml') && <KTSVG
                                          path=""
                                          className="bi bi-filetype-xml"
                                        />}
                                      </button>
                                      <div className='fw-bold'>{a.name}</div>
                                      <br />
                                    </div>
                                 
                                  ))}
                                  </div>
                                 
                                  </div>
                                 
                                  <div className="from">{d.name}  {formatDate(d.created_at)}</div>
                                </div>
                              </div>}
                              {d.incoming === true &&<div className="chat-message-group writer-user">
                                <div className="chat-messages">
                                  <div className="message">{d.body_text}  
                                  {d.attachments.length !==0 &&<div className=' fw-bold text-end'>Archivos adjuntos:</div>}
                                  <div>
                                    {d.attachments.map((a:any,i:any)=>(
                                      <div className='text-end'>
                                      <button key={i} onClick={() =>(typeof props.id === 'string' && (props.id.includes('CRE') || props.id.includes('TRE')) ? handleDownload(a.id,a.name):handleDownloadoldconv(d.id,a.name))} className="btn btn-icon btn-light pulse me-10  bg-light-info">
                                        {a.name.includes('pdf') && <KTSVG
                                          path=""
                                          className="bi bi-file-pdf"
                                        />}
                                        {a.name.toLowerCase().includes('png') && <KTSVG
                                          path=""
                                          className="bi bi-filetype-png"
                                        />}
                                        {a.name.toLowerCase().includes('xlsx') && <KTSVG
                                          path=""
                                          className="bi bi-filetype-xlsx"
                                        />}
                                        {a.name.toLowerCase().includes('jpg') && <KTSVG
                                          path=""
                                          className="bi bi-filetype-jpg"
                                        />}
                                        {a.name.toLowerCase().includes('jpeg') && <KTSVG
                                          path=""
                                          className="bi bi-filetype-jpg"
                                        />}
                                        {a.name.toLowerCase().includes('zip') && <KTSVG
                                          path=""
                                          className="bi bi-file-earmark-zip"
                                        />}
                                        {a.name.toLowerCase().includes('rar') && <KTSVG
                                          path=""
                                          className="bi bi-file-earmark-zip"
                                        />}
                                        {a.name.toLowerCase().includes('xml') && <KTSVG
                                          path=""
                                          className="bi bi-filetype-xml"
                                        />}
                                      </button>
                                      <div className='fw-bold'>{a.name}</div>
                                      <br />
                                    </div>
                                 
                                  ))}
                                  </div>
                                  </div>
                                  <div className="from">{formatDate(d.created_at)}</div>                
 
                                </div>
                              </div>}
                            </div>
                          ))}
                          </div>
                      </div>
                    </div>
 
 
                      <br />
                      {tenant ===0 &&
                      <form className='form w-100' id='kt_login_signin_form' onSubmit={handleSubmit} >
                          <div  style={{width: "100%"}}>
                            <textarea
                              className="chat-textarea border border-gray-400 rounded"
                              placeholder="Write your message . . ."
                              id='reply'
                              value={Reply}
                              onChange={(e:any) => setReply(e.target.value)}
                              >
                            </textarea>
 
                          </div>
                          <div className='fv-row mb-3'>
                            <label className='form-label fw-bolder text-dark fs-6 mb-0'>Attach (Drag and drop screenshots or browse your device)</label>
                              <input
                                ref={inputRef}
                                type="file"
                                className="form-control form-control-solid border-gray-400  "
                                id='files'
                                multiple
                                onChange={(e) => handleChange(e)}
                           
                              />
                          </div>
                          <div className="text-center " style={{width: '100%'}}>
                            <button
                              type='submit'
                              id='kt_sign_in_submit'
                              className='btn btn-primary'
                            >
                              <span className='indicator-label'>Send</span>
                            </button>
                          </div>
                        </form>}
                  </div>
                  </>}
              </div>
            </div>
            {/* end::Modal body */}
          </div>
          {/* end::Modal content */}
        </div>
        {/* end::Modal dialog */}
      </div>
      {/* begin::Modal Backdrop */}
      <div className='modal-backdrop fade show'></div>
      {/* end::Modal Backdrop */}
    </>
  )
}
 
export {ViewModal}